import * as React from 'react'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

export const EmbroideryDisclosure: React.FC<{
  style?: React.CSSProperties
  showCartLogoDigitizationText?: boolean
}> = ({ style, showCartLogoDigitizationText }) => {
  const {
    embroidery: { disclosureText },
  } = useTranslation()
  const viewModel = useViewModel()
  return (
    <Template
      style={style}
      texts={[
        viewModel.siteWideEmbroideryDisclosure ?? disclosureText,
        !!showCartLogoDigitizationText
          ? viewModel.siteWideCartLogoDigitizationWarning ?? undefined
          : undefined,
      ]}
    />
  )
}
